import { render, staticRenderFns } from "./addTarget.vue?vue&type=template&id=d2376d44&"
import script from "./addTarget.vue?vue&type=script&lang=js&"
export * from "./addTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports